import type { RetargetingDisposition } from '@openx/types/targeting/retargeting.ts';

export const retargetingDesignationLabels: Record<RetargetingDisposition, string> = {
  target: 'Retarget',
  suppress: 'Suppress',
};

export const retargetingDesignationOptions: RetargetingDisposition[] = ['target', 'suppress'];
